'use client';
import { TrashIcon } from '@radix-ui/react-icons';
import { Button } from '../ui/Button';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/ui/tooltip';
import { useActiveTabState } from './request.context';

export function PlaygroundNavActions() {
  const { selectedTab, requestState, setRequestState } = useActiveTabState();

  return (
    <>
      {'messages' in requestState && requestState?.messages.length > 0 ? (
        <Tooltip>
          <TooltipContent>
            <p>Clear Chat</p>
          </TooltipContent>
          <TooltipTrigger asChild>
            <Button
              size="sm"
              variant="ghost"
              onClick={() => {
                // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
                switch (selectedTab) {
                  case 'chat':
                    setRequestState({ field: 'messages', value: [] });
                    break;
                  case 'completion':
                    setRequestState({ field: 'prompt', value: '' });
                    break;
                }
              }}
            >
              <span className="sr-only">Clear Chat</span>
              <TrashIcon className="h-6 w-6" />
            </Button>
          </TooltipTrigger>
        </Tooltip>
      ) : null}
    </>
  );
}
